import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Dialog from "@material-ui/core/Dialog";
import MainForm from "./MainForm";
import SettingsTable from "./SettingsTable";

const styles = theme => ({
  //const styles = {
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  },
  addMemberController: {
    marginLeft: theme.spacing.unit + 10,
    marginRight: theme.spacing.unit + 10
  },
  checkBox: {
    marginLeft: 0,
    marginRight: 0,
    margin: 0,
    padding: 0,
    fontSize: "14px"
  },
  formControl: {
    width: "100%"
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  }
});

class AlertOptions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editOpen: false,
      editData: {}
    };
  }

  handleEditSetting = rowData => {
    // Open edit form dialog box
    this.setState({ editOpen: true, editData: rowData });
  };
  handleEditClose = () => {
    this.setState({ editOpen: false });
  };

  render() {
    const {
      classes,
      member,
      Locations,
      type,
      saveAlertSettings,
      updateAlertSettings
    } = this.props;

    return (
      <div className={classes.addMemberController}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <MainForm
              classes={classes}
              member={member}
              Locations={Locations}
              type={type}
              edit={false}
              saveAlertSettings={saveAlertSettings}
              updateAlertSettings={updateAlertSettings}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <SettingsTable
              key={0}
              type={type}
              memberSettings={member.Settings}
              handleEditSetting={this.handleEditSetting}
            />
            <Dialog
              fullWidth={true}
              maxWidth="md"
              open={this.state.editOpen}
              onClose={this.handleEditClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              className={classes.dialogControl}
            >
              <MainForm
                classes={classes}
                member={member}
                Locations={Locations}
                type={type}
                edit={true}
                editData={this.state.editData}
                saveAlertSettings={saveAlertSettings}
                updateAlertSettings={updateAlertSettings}
                handleEditClose={this.handleEditClose}
              />
            </Dialog>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(styles)(AlertOptions);



// WEBPACK FOOTER //
// ./src/components/Alerts/AlertOptions.jsx